// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1__D_","cls2":"ContentFeedback-cls2__OS ContentFeedback-cls1__D_"};